(function(){
  'use strict';
  var C=window.AURA_THEME||{};
  var qs=function(s,c){return (c||document).querySelector(s)};
  var qsa=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var lockCount=0;
  var lastCart=null;
  var lastCartAt=0;

  function emit(name,detail){document.dispatchEvent(new CustomEvent(name,{detail:detail||{}}))}
  function lock(){lockCount+=1;if(lockCount===1)document.body.classList.add('is-locked')}
  function unlock(){lockCount=Math.max(0,lockCount-1);if(lockCount===0)document.body.classList.remove('is-locked')}

  function moneyFromCents(cents){
    var amount=(Number(cents)||0)/100;
    try{return new Intl.NumberFormat(document.documentElement.lang||C.locale||'fr-FR',{style:'currency',currency:C.currency||'EUR'}).format(amount)}
    catch(error){return amount.toFixed(2)+' '+(C.currency||'')}
  }
  window.AuraMoney={fromCents:moneyFromCents};

  function drawer(){return qs('#AuraCartDrawer')}
  function backdrop(){return qs('#AuraCartBackdrop')}

  function openDrawer(trigger){
    var el=drawer(),bg=backdrop();
    if(!el)return;
    el.classList.add('is-open');
    if(bg)bg.classList.add('is-open');
    el.setAttribute('aria-hidden','false');
    if(trigger)el._returnFocus=trigger;
    lock();
    var focusable=qs('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])',el);
    if(focusable)window.setTimeout(function(){focusable.focus()},40);
  }

  function closeDrawer(){
    var el=drawer(),bg=backdrop();
    if(!el)return;
    el.classList.remove('is-open');
    if(bg)bg.classList.remove('is-open');
    el.setAttribute('aria-hidden','true');
    unlock();
    if(el._returnFocus&&document.contains(el._returnFocus))el._returnFocus.focus();
  }

  function cartEndpoint(){return (C.cartUrl||'/cart')+'.js'}
  function fetchCart(){
    return fetch(cartEndpoint(),{headers:{Accept:'application/json'}}).then(function(response){
      if(!response.ok)throw new Error('cart');
      return response.json();
    });
  }

  function renderCartData(cart){
    lastCart=cart;
    lastCartAt=Date.now();
    qsa('[data-cart-count]').forEach(function(node){node.textContent=cart.item_count||0});
    emit('aura:cart:render',{cart:cart});
    return cart;
  }

  function refreshCart(){return fetchCart().then(renderCartData)}
  function openAuraCart(trigger){
    openDrawer(trigger||document.activeElement);
    if(lastCart&&Date.now()-lastCartAt<1500)return Promise.resolve(lastCart);
    return refreshCart().catch(function(){emit('aura:error',{context:'cart'})});
  }

  window.auraRefreshCart=refreshCart;
  window.openAuraCart=openAuraCart;
  window.auraOpenCart=openAuraCart;
  window.closeAuraCart=closeDrawer;

  document.addEventListener('click',function(event){
    var open=event.target.closest('[data-aura-cart-open]');
    if(open){event.preventDefault();openAuraCart(open);return}
    if(event.target.closest('[data-aura-cart-close]')){event.preventDefault();closeDrawer()}

    var wishlist=event.target.closest('[data-aura-wishlist]');
    if(wishlist)emit('aura:wishlist',{productId:wishlist.dataset.productId,handle:wishlist.dataset.productHandle,element:wishlist});

    var back=event.target.closest('[data-aura-back-in-stock]');
    if(back)emit('aura:back-in-stock',{productId:back.dataset.productId,variantId:back.dataset.variantId,element:back});
  });

  document.addEventListener('aura:cart:open',function(event){openAuraCart(event.detail&&event.detail.trigger)});

  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&drawer()&&drawer().classList.contains('is-open'))closeDrawer();
  });

  document.addEventListener('DOMContentLoaded',function(){
    var bg=backdrop();
    if(bg&&!bg.dataset.auraBound){
      bg.dataset.auraBound='true';
      bg.addEventListener('click',closeDrawer);
    }
  });
})();
